import { useEffect, useState } from 'react';
import ContainerComponent from '@/components/common/notes/show-note-forms/form-components/container-component';
import { SET_VALUE } from '@/components/common/notes/show-note-forms/dataToSendReducer';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import decodeHtmlEntities from '@/utils/decodeHtmlEntities';

interface Props {
    value: any;
    formId: string;
    formName: string;
    formDispatch: any;
    item: {
        label: string;
        name: string;
        placeholder: string;
        subtype: string;
        required: boolean;
        values: {
            label: string;
            selected: boolean;
            value: string;
        }[];
        description: string;
    };
    readOnly: boolean;
}

const RadioFieldComponent = ({
    value,
    formDispatch,
    formId,
    formName,
    item: { label, values, name: fieldId, required, description },
    readOnly,
}: Props) => {
    const convertValues = (
        values: {
            label: string;
            selected: boolean;
            value: string;
        }[],
    ) => {
        let out: { [key: string]: boolean } = {};
        values.map((item) => (out[item.value] = item.selected));
        return out;
    };

    const getTrueValue = (values: any) => {
        const keys = Object.keys(values);
        let outKey = null;
        keys.forEach((key) => {
            if (values[key]) outKey = key;
        });
        return outKey;
    };

    const [convertedValues, setConvertedValues] = useState(value ? value : convertValues(values));

    useEffect(() => {
        formDispatch({
            type: SET_VALUE,
            payload: { value: convertedValues, fieldId, formId },
        });
        formDispatch({
            type: SET_VALUE,
            payload: { value: convertedValues, fieldId, formId: formName },
        });
    }, [convertedValues]);

    const handleChange = ({ target: { value } }: any) => {
        const keys = Object.keys(convertedValues);
        let newConvertedValues = { ...convertedValues };
        keys.forEach((key) => {
            newConvertedValues[key] = key === value;
        });
        setConvertedValues(newConvertedValues);
    };

    return (
        <ContainerComponent label={label} required={required} description={description}>
            <RadioGroup value={getTrueValue(convertedValues)} onChange={handleChange}>
                {values.map(({ label, value }) => (
                    <FormControlLabel
                        key={label}
                        value={value}
                        control={<Radio color={'primary'} />}
                        label={decodeHtmlEntities(label)}
                        sx={{ '& .MuiFormControlLabel-label': { fontSize: 14 } }}
                        disabled={readOnly}
                    />
                ))}
            </RadioGroup>
        </ContainerComponent>
    );
};

export default RadioFieldComponent;
